import { render, staticRenderFns } from "./SingleSignOn.vue?vue&type=template&id=ab125ca8"
import script from "./SingleSignOn.vue?vue&type=script&lang=js"
export * from "./SingleSignOn.vue?vue&type=script&lang=js"
import style0 from "./SingleSignOn.vue?vue&type=style&index=0&id=ab125ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports